import React, {useEffect, useRef, useState} from 'react';
import useAuth from "../../hooks/useAuth";
import useAxiosIntercept from "../../hooks/useAxiosIntercept";
import TransactionList from "./TransactionList";
import Pagination from "../Customer/Pagination";

function AccountsData(props) {
    const [expanded, setExpanded] = useState(0);
    const effectRef = useRef(true);
    const {auth} = useAuth();
    const axiosPrivate = useAxiosIntercept();
    const [walletBalance, setWalletBalance] = useState('');

    // const [currentPage, setCurrentPage] = useState(1);
    // const [usersPerPage, setUsersPerPage] = useState(10);
    // const [total_records, setTotalRecords] = useState(0);

    const getWalletBalance = async () =>{
        try{
            let url =  process.env.REACT_APP_GET_BILLING_BALANCE;
            url = `${url}&wallet_id=${auth.wallet_id}`;
            const response = await axiosPrivate.get(url);
            if(response?.data?.response?.data){
                return response?.data?.response?.data;
            }
        }
        catch (err){
            console.log("something went wrong",err);
        }
    }

    useEffect(()=>{
        if(effectRef.current){
            if(auth?.wallet_id != undefined){
                effectRef.current =  false;
                getWalletBalance().then((data)=>{
                    if(data?.balance!=null)
                        setWalletBalance(data.balance);
                });
            }

        }
    },[auth.wallet_id])

    // const paginate = (number) => {
    //     setCurrentPage(number);
    // };
    return (
        <div className="contentContainer">
            <h2 className="mHeadingWrap">
                Accounts
                <div className="boxT1">
                    <p>
                        <span>Wallet balance</span>
                        {walletBalance > 0 ?
                            <span className="success">${walletBalance}</span>
                            :
                            <span className="error">-${Math.abs(walletBalance)}</span>
                        }
                    </p>
                </div>
            </h2>
            <TransactionList/>


            {/* <div class="searchPanel">
              <div class="searchBar">
                  <i class="material-symbols-rounded mt-m grey">search</i>
                  <input type="search" placeholder="Search any customer by name, email, phone">
              </div>
              <a href="newCustomer.php" class="btn prim">Add new customer</a>
          </div> */}

        </div>

    );
}

export default AccountsData;

